import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('InfoBox')(css({
    display: 'flex',
    backgroundColor: 'infoLabel',
    justifyContent: 'space-between',
    py: 'xs',
    px: 's',
    my: 'xs',
}));
themeStyles.addBaseStyles('ProtectionCardWrapper')(() => css({
    maxWidth: ['100%', '100%', '464px'],
    '& > *:not(last-child)': {
        mb: ['m', 'm', '24px'],
    },
    '& > *:last-child': {
        mb: '10px',
    },
}));
themeStyles.addBaseStyles('Container')(() => css({
    width: '100%',
}));
themeStyles.addBaseStyles('HeaderContainer')(() => css({
    display: 'flex',
    justifyContent: 'space-between',
}));
themeStyles.addBaseStyles('ProtectionCardsContainer')(() => css({
    display: 'flex',
    flexDirection: 'column',
}));
themeStyles.addBaseStyles('AccessoryCardContainer')(() => css({
    mx: 'zero',
    py: ['17px', '17px', 'l'],
    pr: '4px',
    mr: ['zero', 'zero', 'xs'],
}));
themeStyles.addBaseStyles('ViewMoreAccessoriesCta')(() => css({
    fontSize: 's',
    lineHeight: '22px',
    fontFamily: 'bold',
    mt: '16px',
}));
themeStyles.addBaseStyles('CarouselWrapper')(() => css({
    ml: ['-8px', '-8px', '-15px'],
    mr: ['-24px', '-24px', '-24px'],
    pr: ['zero', 'zero', '5px'],
    pl: ['zero', 'zero', '5px'],
    mt: 'm',
    overflow: 'hidden',
}));
themeStyles.addBaseStyles('ModalContentWrapper')(() => css({
    // 178px taken from modal header + ctas
    height: ['calc(100dvh - 178px)', '100%', '100%'],
    // accounts for samsung tablet viewport
    '@media only screen and (min-width: 740px) and (max-width: 768px)': {
        height: '100%',
    },
}));
themeStyles.addBaseStyles('ModalCardsWrapper')(() => css({
    // 112px taken from logo + price
    maxHeight: ['calc(100% - 112px)', 'calc(100% - 112px)', '433px'],
    overflowY: 'scroll',
    overflowX: 'hidden',
}));
export default themeStyles;
